// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"d44ef98b","439":"976aae30","533":"ab01d938"}[chunkId] + ".chunk.css";
};